import React, { useState, useRef, useEffect } from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
};

export default function FAQItem({ title, children, icon }: Props) {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [maxH, setMaxH] = useState<string>('0px');

  useEffect(() => {
    if (open) {
      const height = contentRef.current?.scrollHeight ?? 0;
      // set to scrollHeight to allow smooth expand
      setMaxH(`${height}px`);
    } else {
      // collapse
      setMaxH('0px');
    }
  }, [open]);

  return (
    <article className="relative rounded-2xl border border-[#d9dbd2] bg-white/95">
      <div className="flex items-center gap-4 p-5">
        <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[#ecefe7] text-xl text-[#2f5d48]">
          {icon}
        </div>

        <div className="min-w-0 flex-1">
          <div className="w-full text-left">
            <button
              aria-expanded={open}
              onClick={() => setOpen(v => !v)}
              className="w-full flex items-center justify-between"
            >
              <h3 className="text-base font-bold leading-7 text-[#2f4f42]">{title}</h3>
              <span className={`ml-4 inline-flex h-8 w-8 items-center justify-center rounded-full border bg-white text-sm text-[var(--brand-accent)] transform transition-transform duration-200 ${open ? 'rotate-45' : 'rotate-0'}`}>{open ? '−' : '+'}</span>
            </button>

            <div
              ref={contentRef}
              style={{ maxHeight: maxH, transition: 'max-height 320ms ease' }}
              className="overflow-hidden"
            >
              <div className={`mt-3 text-sm leading-7 text-[#5e675f] transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
}
